import styled from 'styled-components';

export const PremiumStyled = styled.div`
  width: 100%;
  padding: 0;
  background-color: ${({ theme }) => theme.colors.blueShadow};

  & p {
    font-weight: 500;
  }
`;

export const ContainerStyled = styled.div`
  max-width: 1300px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 30px 18.5px;
  gap: 30px;

  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    padding: 50px 76px;
  }
  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    padding: 50px 205px;
  }

  .main-head {
    font-size: 20px;
    line-height: 32px;
    text-align: center;
    font-weight: bold;
    @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
      font-size: 24px;
      line-height: 50px;
    }
    @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
      font-size: 32px;
    }
  }

  .main-text {
    font-size: 14px;
    line-height: 25px;
    text-align: center;
    @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
      font-size: 16px;
      line-height: 32px;
    }
    @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
      font-size: 20px;
    }
  }
`;
